var React = require('react');

function YoutubeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"fill","fillRule":"nonzero","d":"M30 8.69933C30 6.10382 27.9929 4 25.5164 4H4.48357C2.00714 4 0 6.10382 0 8.69933V21.3007C0 23.8962 2.00714 26 4.48357 26H25.5164C27.9929 26 30 23.8962 30 21.3007V8.69933ZM12 20.3165V8.48031L20.5671 14.3984L12 20.3165Z"}));
}

YoutubeInline.defaultProps = {"viewBox":"0 0 30 30"};

module.exports = YoutubeInline;

YoutubeInline.default = YoutubeInline;
